import { render, staticRenderFns } from "./BooksEn.vue?vue&type=template&id=05674b65&scoped=true&"
import script from "./BooksEn.vue?vue&type=script&lang=js&"
export * from "./BooksEn.vue?vue&type=script&lang=js&"
import style0 from "./BooksEn.vue?vue&type=style&index=0&id=05674b65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05674b65",
  null
  
)

export default component.exports